import React, { useEffect } from 'react';
import { View, ScrollView } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';

import { Header } from '../../../components/common';
import { AppButton, AppText } from '../../../components/form';
import { DonutChart, LineChart } from '../../../components/graph';
import { pixelDimensions } from '../../../config/utils';
import { getPNFAM } from '../../../redux/actions/companyActions';
import styles from './styles';

const CircleQuestion = ({ text, responses }) => (
  <View style={styles.questions}>
    <AppText size="bold" style={styles.textQA}>{text}</AppText>
    <View style={styles.viewResponses}>
      {
        responses.map((response, index) => (
          <View key={index}>
            <View style={styles.viewCircle}>
              <AppText style={styles.textQuestion}>{`${Object.values(response)[0]}%`}</AppText>
            </View>
            <AppText style={styles.textQuestion}>{Object.keys(response)[0]}</AppText>
          </View>
        ))
        }
    </View>
  </View>
);

const PNFAM = ({ navigation }) => {
  const { companyData, pnfamData } = useSelector((state) => state.company);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPNFAM(companyData.id_empresa));
  }, []);
  const getLevel = (level) => {
    switch (parseInt(level, 10)) {
      case 1: return '1';
      case 2: return '2';
      case 3: return '3';
      case 4: return '4';
      case 5: return '5';
      case 6: return '6';
      case 7: return '7';
      case 8: return '8';
      case 9: return '9';
      case 10: return '10';
      default: return 'Sem Dados';
    }
  };
  return (
    <ScrollView>
      <Header navigation={navigation} profilePic={companyData.foto} userName={companyData.nome} />

      <View style={styles.container}>
        <AppText size="bold" style={[styles.textCenter, styles.textTitle]}>Relatório - PNFAM</AppText>
        <AppText style={[styles.textCenter, styles.textSubTitle]}>{'Pesquisa de Nível — Físico,\nAlimentar e Mental'}</AppText>

        <View style={styles.viewEvaluation}>
          <View style={styles.viewGraph}>
            <DonutChart radius={15} percentage={(pnfamData.qtd_respostas / pnfamData.qtd_colaboradores) * 100} width={100} />
            <AppText style={[styles.textCenter, styles.textAnswers]}>{`${pnfamData.qtd_respostas} Respostas\n${pnfamData.qtd_colaboradores} Colaboradores — Total`}</AppText>
          </View>
          <View style={styles.viewLinesContainer}>
            <LineChart name="Cervical" percentage={pnfamData.cervical.toFixed(1)} />
            <LineChart name="Centro Costas" percentage={pnfamData.centro_costas.toFixed(1)} />
            <LineChart name="Lombar" percentage={pnfamData.lombar.toFixed(1)} />
            <LineChart name="Peitoral" percentage={pnfamData.peitoral.toFixed(1)} />
            <LineChart name="Ombro E" percentage={pnfamData.ombro_esquerdo.toFixed(1)} />
            <LineChart name="Ombro D" percentage={pnfamData.ombro_direito.toFixed(1)} />
            <LineChart name="Perna E" percentage={pnfamData.perna_esquerda.toFixed(1)} />
            <LineChart name="Perna D" percentage={pnfamData.perna_direita.toFixed(1)} />
            <LineChart name="Punho E" percentage={pnfamData.punho_esquerdo.toFixed(1)} />
            <LineChart name="Punho D" percentage={pnfamData.punho_direito.toFixed(1)} />
            <LineChart name="Pé E" percentage={pnfamData.pe_esquerdo.toFixed(1)} />
            <LineChart name="Pé D" percentage={pnfamData.pe_direito.toFixed(1)} />
          </View>
          <View>
            <View style={styles.viewQuestion}>
              <AppText size="bold" style={styles.textQA}>{'Tem cansaço físico no final\nda sua jornada de trabalho?'}</AppText>
              <AppText style={styles.textQA}>{`${pnfamData.qtd_respostas > 0 ? ((pnfamData.qtd_cansaco_fisico / pnfamData.qtd_respostas) * 100).toFixed(1) : pnfamData.qtd_respostas}% Sim`}</AppText>
            </View>
            <View style={styles.viewLinesContainer}>
              <LineChart marginRight name="Estresse" percentage={pnfamData.estresse.toFixed(1)} />
              <LineChart name="Ansiedade" percentage={pnfamData.ansiedade.toFixed(1)} />
              <View>
                <LineChart name="Qualidade do Sono" percentage={((pnfamData.qualidade_sono / 2) * 100).toFixed(1)} showValue={false} />
                <View style={styles.viewDreamQuality}>
                  <AppText style={styles.textQA}>Baixa</AppText>
                  <AppText style={styles.textQA}>Média</AppText>
                  <AppText style={styles.textQA}>Alta</AppText>
                </View>
              </View>
            </View>

            <CircleQuestion
              text="Tem dores de cabeça frequente?"
              responses={[
                { Sim: pnfamData.qtd_respostas > 0 ? ((pnfamData.qtd_dor_cabeca / pnfamData.qtd_respostas) * 100).toFixed(0) : pnfamData.qtd_respostas },
                { Nâo: pnfamData.qtd_respostas > 0 ? (100 - (pnfamData.qtd_dor_cabeca / pnfamData.qtd_respostas) * 100).toFixed(0) : pnfamData.qtd_respostas }]}
            />
            <View style={{ marginVertical: pixelDimensions(2) }}>
              <View style={styles.viewQuestion}>
                <AppText size="bold" style={styles.textQA}>{'Qualidade da\nAlimentação Semanal'}</AppText>
                <AppText style={styles.textQA}>{ getLevel(pnfamData.qualidade_alimentacao.toFixed(0))}</AppText>
              </View>
              <View style={styles.viewQuestion}>
                <AppText size="bold" style={styles.textQA}>{'Ingestão de\nalimentos Saudáveis'}</AppText>
                <AppText style={styles.textQA}>{ getLevel(pnfamData.alimentos_saudaveis.toFixed(0))}</AppText>
              </View>
              <View style={styles.viewQuestion}>
                <AppText size="bold" style={styles.textQA}>Ingestão de lanches</AppText>
                <AppText style={styles.textQA}>{ getLevel(pnfamData.lanches.toFixed(0))}</AppText>
              </View>
              <View style={styles.viewQuestion}>
                <AppText size="bold" style={styles.textQA}>{'Ingestão de frituras\ne Gorduras'}</AppText>
                <AppText style={styles.textQA}>{ getLevel(pnfamData.frituras_gorduras.toFixed(0))}</AppText>
              </View>
              <View style={styles.viewQuestion}>
                <AppText size="bold" style={styles.textQA}>Ingestão de Frutas</AppText>
                <AppText style={styles.textQA}>{ getLevel(pnfamData.frutas)}</AppText>
              </View>
            </View>
            <CircleQuestion
              text={'Está seguindo algum plano\nde alimentação saudável?'}
              responses={[
                { Sim: pnfamData.qtd_respostas > 0 ? ((pnfamData.qtd_plano_alimentacao / pnfamData.qtd_respostas) * 100).toFixed(0) : pnfamData.qtd_respostas },
                { Nâo: pnfamData.qtd_respostas > 0 ? (100 - (pnfamData.qtd_plano_alimentacao / pnfamData.qtd_respostas) * 100).toFixed(0) : pnfamData.qtd_respostas }]}
            />
            <CircleQuestion
              text={'Deseja Melhorar Sua\nAlimentação Diária?'}
              responses={[
                { Sim: pnfamData.qtd_respostas > 0 ? ((pnfamData.qtd_melhorar_alimentacao_sim / pnfamData.qtd_respostas) * 100).toFixed(0) : pnfamData.qtd_respostas },
                { Nâo: pnfamData.qtd_respostas > 0 ? (((pnfamData.qtd_respostas - pnfamData.qtd_melhorar_alimentacao_talvez - pnfamData.qtd_melhorar_alimentacao_sim) / pnfamData.qtd_respostas) * 100).toFixed(0) : pnfamData.qtd_respostas },
                { Talvez: pnfamData.qtd_respostas > 0 ? ((pnfamData.qtd_melhorar_alimentacao_talvez / pnfamData.qtd_respostas) * 100).toFixed(0) : pnfamData.qtd_respostas }]}
            />
          </View>
        </View>

        <AppButton
          size="bold"
          label="VOLTAR"
          style={styles.buttonBack}
          labelStyle={styles.textBack}
          onPress={() => navigation.goBack()}
        />
      </View>
    </ScrollView>
  );
};

export default PNFAM;
